import React from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import moment from 'moment';
import useCalendarStyles from '../availabilities/hooks/useCalendarStyles';
import Hour from './Hour';
import SideHours from './SideHours';

function Day(props) {
  const { day, type, onWeekDayClick, children, sideHours, displaySideHours, displayHourCase, onCalendarCaseClick, highlightToday, admin = true, selectedCalendarDay, setSelectedCalendarDay, disabled } = props;
  const { dateString, weekDayName, hours, dayOfWeek, date } = day;
  const { Card, CardContent } = useUiContext();
  const { classes } = useCalendarStyles();

  const today = moment().format('YYYY-MM-DD');
  const isToday = date === today;

  const handleOnDayClick = () => {
    setSelectedCalendarDay(day);
  };

  const renderDateSidebar = () => (
    <div className={`month-card-sidebar ${selectedCalendarDay?.date === date ? 'active-date' : ''} ${disabled ? 'past-date' : ''}`}>
      <span className="day-of-week">{dayOfWeek}</span>
    </div>
  );

  if (type === 'Week' || type === 'Day') {
    let columnClass;
    if (isToday && type === 'Week' && highlightToday) {
      columnClass = classes.calendarColumnToday;
    } else if (displaySideHours) {
      columnClass = classes.calendarColumnWithSideHours;
    } else {
      columnClass = classes.calendarColumn;
    }

    const headerClickProps = {};
    if (type === 'Week') {
      headerClickProps.onClick = onWeekDayClick(date);
      headerClickProps.onKeyDown = (e) => { if (e.key === 'Enter' || e.key === ' ') onWeekDayClick(date)(); };
      headerClickProps.role = 'button';
      headerClickProps.tabIndex = 0;
    }

    return (
      <div className={columnClass}>
        {type === 'Day' && displaySideHours && <SideHours hours={sideHours} />}
        <span className={classes.calendarColumnHeader} {...headerClickProps}>
          <span className={classes.calendarColumnHeaderDay}>
            {weekDayName}
          </span>
          <span className={classes.calendarColumnHeaderDate}>
            {dateString}
          </span>
        </span>
        {hours.map((hour) => {
          const { time, datetime } = hour;

          if (displayHourCase) {
            return (
              <Hour key={time} hour={hour} displayType={type} displaySideHours={displaySideHours} onCalendarCaseClick={onCalendarCaseClick ? onCalendarCaseClick(datetime) : null}>
                {children(hour)}
              </Hour>
            );
          }
          return children(hour);
        })}
      </div>
    );
  }

  const handleMonthViewClick = () => {
    if (admin) {
      onWeekDayClick(date);
    } else if (!disabled) {
      handleOnDayClick();
    }
  };

  if (type === 'Month') {
    return (
      <Card className={`${classes.monthCard} month-card-wrapper`} elevation={0} onClick={handleMonthViewClick} id={date}>
        <CardContent className={`${classes.monthCardContent} month-card-content`}>
          <div className="month-card-flex">
            {renderDateSidebar()}
            <div className="month-card-children-content">
              {children(day)}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
  return null;
}

Day.defaultProps = {
  type: 'Week',
  onWeekDayClick: null,
  onCalendarCaseClick: null,
  displaySideHours: true,
  sideHours: [],
  displayHourCase: true,
  highlightToday: false,
};

Day.propTypes = {
  displaySideHours: PropTypes.bool,
  type: PropTypes.string,
  day: PropTypes.object.isRequired,
  onWeekDayClick: PropTypes.func,
  onCalendarCaseClick: PropTypes.func,
  sideHours: PropTypes.arrayOf(PropTypes.string),
  displayHourCase: PropTypes.bool,
  highlightToday: PropTypes.bool,
};

export default Day;
